import  './index'
import axios from '@/http/axios'

async function getLiveCities () {
  const token = localStorage.accessToken
  return axios.get('/api/live-cities', {
    params: {
    },
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}
async function getLiveCity (cityId) {
  const token = localStorage.accessToken
  
  return axios.get(`/api/live-cities/${cityId}`, {
    params: {
    },
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}

async function saveLiveCity (payload) {
  const token = localStorage.accessToken
  return axios.post('/api/live-cities', payload, {
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}
async function updateLiveCity (payload) {
  const token = localStorage.accessToken
  
  return axios.put(`/api/live-cities/${payload.cityId}`, payload, {
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}

async function deleteLiveCity (cityId) {
  const token = localStorage.accessToken
  
  return axios.delete(`/api/live-cities/${cityId}`, {
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}
export {
  getLiveCity, getLiveCities, saveLiveCity, updateLiveCity, deleteLiveCity
}
